import { Tag, TagsAPI } from '@brg/api';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

export interface IGrouppedTags<T> {
    isEducationTag?: boolean;
    categoryId?: string;
    childrens?: T[];
    found?: number;
    position?: number;
    groupId?: string | null;
    categoryTitle?: string;
}

interface HeaderTag {
    current?: Tag,
    parent?: Tag
}

export interface TagsSliceState {
    tagsList: IGrouppedTags<Tag>[]
    headerTag: HeaderTag
    selectedTags: Tag[]
    tagCategories: Tag[]
    tagCategoriesLoaded: boolean
    selectedTagsIndex: { [key: string]: boolean }
    searchText: string
    newTag: Tag | null
    onSave: (val: Tag[]) => void | null
    tagCategoriesIndex: Map<string, { name: string, tagId: string }>
}

export const loadTagCategories = createAsyncThunk<any, {}>(
    'tagCategories/Load',
    async (_, thuncApi) => {
        try {
            const state = thuncApi.getState();
            // @ts-ignore
            if (state?.tags?.tagCategoriesLoaded) {
                return thuncApi.rejectWithValue('Tag categories already loaded');
            }

            let categories = await TagsAPI.GetTagsTree({ onlyCategories: true, status: [0], isHeaderIgnored: true, includeSubCategories: true/*, exceptEntityTypes: 'hidden_category'*/ })
            // @ts-ignore
            categories = await categories.json()
            return categories
        } catch (err: any) {
            return thuncApi.rejectWithValue(err?.message)
        }
    }
)

export const TagsSlice = createSlice({
    name: 'tags',
    initialState: {
        tagsList: [],
        headerTag: {
            current: null,
            parent: null,
        },
        selectedTags: [],
        tagCategories: [],
        tagCategoriesLoaded: false,
        selectedTagsIndex: {},
        searchText: '',
        newTag: null,
        onSave: null,
        tagCategoriesIndex: new Map()
    },
    reducers: {
        setTags: (state, action) => {
            state.tagsList = action.payload;
        },
        setTagCategoriesLoaded: (state, action) => {
            state.tagCategoriesLoaded = action.payload;
        },
        updateTags: (state, action) => {
            state.tagsList = action.payload;
        },
        setHeaderTag: (state, action) => {
            state.headerTag = {
                ...state.headerTag,
                ...action.payload
            };
        },
        setSelectedTags: (state, action) => {
            state.selectedTags = action.payload;
            //@ts-ignore
            state.selectedTagsIndex = action.payload.reduce((result, tag) => {
                return {
                    ...result,
                    [tag.tagId]: true,
                }
            }, {});
        },
        setOnSave: (state, action) => {
            state.onSave = action.payload;
        },
        setSearchText: (state, action) => {
            state.searchText = action.payload;
        },
        setNewTag: (state, action) => {
            state.newTag = action.payload
        }
    },
    extraReducers: {
        [loadTagCategories.fulfilled.toString()]: (state, action) => {
            state.tagCategories = action.payload
            state.tagCategoriesIndex = action.payload.reduce((result: any, tag: Tag) => {
                result.set(tag.tagId, {
                    name: tag.name,
                    tagId: tag.tagId,
                })
                return result;
            }, new Map());

        },
        [loadTagCategories.pending.toString()]: (state) => {
        },
        [loadTagCategories.rejected.toString()]: (state, action) => {
        },
    },
});

export default TagsSlice
export const TagsActions = TagsSlice.actions
export const TagsSelector = (store: { tags: TagsSliceState }): TagsSliceState => store.tags;
export const TagCategoriesSelector = (store: { tags: TagsSliceState }): Map<string, { name: string, tagId: string }> => store?.tags?.tagCategoriesIndex;import { Tag, TagsAPI } from '@brg/api';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

export interface IGrouppedTags<T> {
    isEducationTag?: boolean;
    categoryId?: string;
    childrens?: T[];
    found?: number;
    position?: number;
    groupId?: string | null;
    categoryTitle?: string;
}

interface HeaderTag {
    current?: Tag,
    parent?: Tag
}

export interface TagsSliceState {
    tagsList: IGrouppedTags<Tag>[]
    headerTag: HeaderTag
    selectedTags: Tag[]
    tagCategories: Tag[]
    tagCategoriesLoaded: boolean
    selectedTagsIndex: { [key: string]: boolean }
    searchText: string
    newTag: Tag | null
    onSave: (val: Tag[]) => void | null
    tagCategoriesIndex: Map<string, { name: string, tagId: string }>
}

export const loadTagCategories = createAsyncThunk<any, {}>(
    'tagCategories/Load',
    async (_, thuncApi) => {
        try {
            const state = thuncApi.getState();
            // @ts-ignore
            if (state?.tags?.tagCategoriesLoaded) {
                return thuncApi.rejectWithValue('Tag categories already loaded');
            }

            let categories = await TagsAPI.GetTagsTree({ onlyCategories: true, status: [0], isHeaderIgnored: true, includeSubCategories: true/*, exceptEntityTypes: 'hidden_category'*/ })
            // @ts-ignore
            categories = await categories.json()
            return categories
        } catch (err: any) {
            return thuncApi.rejectWithValue(err?.message)
        }
    }
)

export const TagsSlice = createSlice({
    name: 'tags',
    initialState: {
        tagsList: [],
        headerTag: {
            current: null,
            parent: null,
        },
        selectedTags: [],
        tagCategories: [],
        tagCategoriesLoaded: false,
        selectedTagsIndex: {},
        searchText: '',
        newTag: null,
        onSave: null,
        tagCategoriesIndex: new Map()
    },
    reducers: {
        setTags: (state, action) => {
            state.tagsList = action.payload;
        },
        setTagCategoriesLoaded: (state, action) => {
            state.tagCategoriesLoaded = action.payload;
        },
        updateTags: (state, action) => {
            state.tagsList = action.payload;
        },
        setHeaderTag: (state, action) => {
            state.headerTag = {
                ...state.headerTag,
                ...action.payload
            };
        },
        setSelectedTags: (state, action) => {
            state.selectedTags = action.payload;
            //@ts-ignore
            state.selectedTagsIndex = action.payload.reduce((result, tag) => {
                return {
                    ...result,
                    [tag.tagId]: true,
                }
            }, {});
        },
        setOnSave: (state, action) => {
            state.onSave = action.payload;
        },
        setSearchText: (state, action) => {
            state.searchText = action.payload;
        },
        setNewTag: (state, action) => {
            state.newTag = action.payload
        }
    },
    extraReducers: {
        [loadTagCategories.fulfilled.toString()]: (state, action) => {
            state.tagCategories = action.payload
            state.tagCategoriesIndex = action.payload.reduce((result: any, tag: Tag) => {
                result.set(tag.tagId, {
                    name: tag.name,
                    tagId: tag.tagId,
                })
                return result;
            }, new Map());

        },
        [loadTagCategories.pending.toString()]: (state) => {
        },
        [loadTagCategories.rejected.toString()]: (state, action) => {
        },
    },
});

export default TagsSlice
export const TagsActions = TagsSlice.actions
export const TagsSelector = (store: { tags: TagsSliceState }): TagsSliceState => store.tags;
export const TagCategoriesSelector = (store: { tags: TagsSliceState }): Map<string, { name: string, tagId: string }> => store?.tags?.tagCategoriesIndex;